import React, { useEffect, useRef } from "react";
import styles from "./CrewSection.module.css";

const crewData = [
  { img: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/crew1.jpeg", name: "Vimanyu Shewalkar", role: "Restaurant Manager" },
  // { img: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/crew2.jpeg", name: "Deb Kumar Chatterjee", role: "Operations Manager" },
  { img: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/crew3.jpeg", name: "Bir Bahadur", role: "Head Chef" },
  { img: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/crew4.jpg", name: "Niriksha Amin", role: "Head Accountant" },
  // { img: "https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/Saif%20Sayyed%20.JPG%20(2).jpeg", name: "Saif Sayyed", role: "Guest Experience Executive" },
];

const CrewSection = () => {
  const sectionRef = useRef(null);
  const totalItems = crewData.length;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add(styles.show);
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.container}>
        <div className={styles.topRow}>
          <h2>MEET OUR CREW</h2>
        </div>

        <div className={styles.grid} data-count={totalItems}>
          {crewData.map((member, index) => (
            <div key={index} className={styles.card}>
              <img src={member.img} alt={member.name} />
              <div className={styles.overlay}></div>
              <div className={styles.content}>
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CrewSection;